import { FaArrowUp, FaClock } from "react-icons/fa";

const StatsCard = ({ title, amount, footer, type }) => {
  return (
    <div className="card stats-card">
      <div className="stats-header">
        <h4>{title}</h4>
      </div>

      <h2 className="stats-amount">{amount}</h2>

      <p className={`stats-footer ${type}`}>
        {type === "success" ? <FaArrowUp /> : <FaClock />}
        {footer}
      </p>
    </div>
  );
};

export default StatsCard;
